<template>
    <h2 class="course-heading">Your Supplemental Materials</h2>
    <blockquote class="blockquote">
        <p>
            You have {{ booksCount }} ITEM<span v-if="booksCount  > 1">S</span> available
            for your {{ this.$store.state.adoptions.length }} COURSE<span
                v-if="this.$store.state.adoptions.length > 1">S</span> selected.
        </p>
    </blockquote>
    <div class="col-sm-12">
        <span class="text-primary">Need to change your courses?</span>&nbsp;
        <button class="btn btn-outline-primary slim-btn" @click="goToHome()">
            <span class="material-icons-outlined btn-icon"> arrow_circle_left </span>
            Reset Course Selection
        </button>
    </div>
    <div class="col-sm-12 mt-3" v-for="(adopted, index) in this.$store.state.adoptions" :key="adopted.id"
        :value="adopted.id">
        <div class="accordion" id="accordionPanelsStayOpenExample">
            <div class="accordion-item">
                <h2 class="accordion-header" :id="'panelsStayOpen-headingOne'">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" aria-expanded="true"
                        :data-bs-target="'#panelsStayOpen-body' + index" :aria-controls="'panelsStayOpen-body' + index">
                        <div class="">
                            <h3 class="text-primary f-24">
                                <div>
                                    {{ adopted.termName }} {{ adopted.deptCode }}
                                    {{ adopted.sectionName }} {{ this.getBooksCount(adopted.adoptions) }} -
                                    {{ adopted.courseName }}
                                </div>
                            </h3>
                            <div class="">
                                <span class="professor">Professor
                                    {{
                                    adopted.instructorName
                                    ? adopted.instructorName.toUpperCase()
                                    : "-"
                                    }}</span>
                            </div>
                        </div>
                    </button>
                </h2>
                <div :id="'panelsStayOpen-body' + index" class="accordion-collapse collapse show">
                    <div class="accordion-body" v-if="adopted.adoptions.length == 0">
                        <SelectionPending />
                    </div>
                    <div class="accordion-body" v-else-if="adopted.adoptions[0]!=null && adopted.adoptions[0].book?.isbn==null ">
                        <NoMaterialsRequired :book="adopted.adoptions[0]"/>
                    </div>
                    <div class="accordion-body" v-else>
                        <div class="col-sm-12">
                            <div class="row" v-for="(item, count) in adopted.adoptions" :key="item.book.isbn"
                                :value="item.book.isbn">
                                <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 text-center">
                                    <img src="../assets/imagenotfound.jpg" class="book-cover" />
                                </div>
                                <div class="col-sm-10">
                                    <span class="badge suggestion-type-req" v-if="item.suggestion">{{
                                    item.suggestion == 1 ? 'RECOMMENDED' : 'REQUIRED'}}
                                    </span>
                                    <h4 class="text-primary">
                                        {{ item.book.title }}
                                    </h4>
                                    <span>By </span>
                                    <span v-for="(author, index) in item.book.bookAuthors" :key="author.author.id"
                                        :value="author.author.id">
                                        {{author.author.name }}
                                        <span v-if="index != item.book.bookAuthors.length - 1"> / </span>
                                    </span>
                                    <div class="flex-container">
                                        <div class="flex-component-1">
                                            <div class="form-group">
                                                <label class="font-weight-bold">Edition:&nbsp;</label>
                                                <span>{{ item.book.edition }}</span>
                                            </div>
                                            <div class="form-group">
                                                <label class="font-weight-bold">Publisher:&nbsp;</label>
                                                <span>{{
                                                item.book.publisher ? item.book.publisher : "Not Available"
                                                }}</span>
                                            </div>
                                            <div class="form-group">
                                                <label class="font-weight-bold">ISBN:&nbsp;</label>
                                                <span>{{ item.book.isbn }}</span>
                                            </div>
                                            <div class="form-group row">
                                                <div class="col-sm-2 pe-0 notes"><label class="font-weight-bold">NOTES:&nbsp;</label></div>
                                                
                                                <div class="col-sm-6 p-0" v-if="item.notes!=null" v-html="item.notes"></div>
                                                 <div class="col-sm-6 p-0" v-else>
                                                    <p class="">Not Available</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="search-web">
                                            <a :href="'https://www.amazon.com/s?k=' + item.book.isbn" target="_blank">
                                                <img src="../assets/amazonicon.jpg" class="search-element" alt="Amazon"
                                                    title="Shop at Amazon" />
                                            </a>
                                            <a :href="
                                                'https://books.google.com/books?q=isbn:' +
                                                item.book.isbn +
                                                '&c=books'
                                            " target="_blank">
                                                <img src="../assets/google-icon.png" class="search-element"
                                                    height="31px" alt="Google Search" title="Search in Google" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="count != adopted.adoptions.length - 1">
                                    <hr />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SelectionPending from './PendingSelection.vue'
import NoMaterialsRequired from './NoMaterialsRequired.vue'
export default {
    name: "MaterialListing",
    components: {
        SelectionPending,
        NoMaterialsRequired
    },
    data() {
        return {
            sections: [],
            adoption: [],
            books: [],
            suggestiontypes: [],
            coursecount: this.coursecount,
            booksCount: 0,
        };
    },
    computed: {
        getCourses() {
            return this.courses;
        },


    },
    methods: {
        getBooksCount(books) {
            if (books.length == 0) {
                return '';
            }
            let required = books.filter(x => x.suggestion == 2).length;
            let recommended = books.filter(x => x.suggestion == 1).length;
            if (required > 0 && recommended > 0) {
                return '(' + required + ' required, ' + recommended + ' recommended)'
            }
            else if (required > 0) {
                return '(' + required + ' required)'
            }
            else if (recommended > 0) {
                return '(' + recommended + ' recommended)'
            }
            return '';

        },
        addCourseItem() {
            this.courses.push({
                termId: null,
                departmentId: null,
                courseId: null,
                sectionId: null,
            });
        },
        //To reset the fields
        resetCourseSelection(index) {
            this.courses[index].termId = null;
            this.courses[index].departmentId = null;
            this.courses[index].courseId = null;
            this.courses[index].sectionId = null;
        },
        goToHome() {
            this.$router.push("material-finder");
        },
        getAdoptions(sectiondetails) {
            this.$store.dispatch("getAdoptions", sectiondetails);
        },
        getCount() {
            return 0;
            // if (this.$store.state.adoptions.length == 0 || !this.$store.state.adoptions) {
            //     return 0;
            // }
            // let books = this.$store.state.adoptions.map((x) => x.adoptions).filter((x) => x.length > 0);
            // let count = 0;
            // books.forEach(book => {
            //     if (book != null && book[0].isbn != null) {
            //         count = count + book.length;
            //     }
            // });
            // return count;
        },
    },
    mounted() {
        this.$store.state.student.courseFinder =
            this.$store.state.student.courseFinder.filter((x) => x.sectionId);
        if (this.$store.state.student.courseFinder.length == 0) {
            if (sessionStorage.getItem('courseFinder')) {
                this.$store.state.student.courseFinder = JSON.parse(sessionStorage.getItem('courseFinder'));
            }
        }

        sessionStorage.setItem('courseFinder', JSON.stringify(this.$store.state.student.courseFinder));
        this.sections = this.$store.state.student.courseFinder.map(
            (x) => x.sectionId
        );
        this.$store.dispatch("getAdoptions", this.sections).then(() => {
            this.adoption = this.$store.state.adoptions;
            this.coursecount = this.$store.state.adoptions.length;
            let books = this.adoption.map((x) => x.adoptions).filter((x) => x.length > 0);
            let count = 0;
            books.forEach(book => {
                if (book != null && book[0].book?.isbn != null) {
                    count = count + book.length;
                }
            });
            this.booksCount = count;
        });
    },
};
</script>
<style scoped>
.course-heading {
    color: #006747;
    font-weight: normal;
}

.horizontal-border {
    margin: 0px;
}

.card-title {
    margin-bottom: auto !important;
}

.accordion-button:not(.collapsed) {
    color: #212529 !important;
    background-color: #fff !important;
}

.info-icon {
    font-size: 88px;
    color: orange;
}

.font-weight-bold {
    font-weight: 500;
}

.suggestion-type-req {
    background-color: #9c0f2e;
    font-family: sans-serif;
}

.search-web {
    padding-right: 5px;
    padding-left: 80px;
    padding-top: 10px;
}

.search-element {
    padding-right: 8px;
    height: 30px !important;
}

.flex-container {
    display: flex;
}

.flex-component-1 {
    width: 500px;
}

.f-24 {
    font-size: 24px;
}

.book-cover {
    height: 150px !important;
}
.notes {
width: 71px;
}
</style>